import { Component, Input, ViewEncapsulation, ElementRef, inject, PLATFORM_ID } from '@angular/core';
import { CommonModule , isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'admin-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrl: './header-menu.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule],
  host: {
    '(document:click)': 'closeMenuEventListener($event)'
  }
})
export class HeaderMenuComponent {
  /* This is Used for ARIA label */
  @Input() menuName = 'Main';
  @Input() toggleText: string;
  @Input() toggleClass: string;
  public menuExpanded = false;

  // Using the new inject pattern instead of constructor injection
  private elementRef = inject(ElementRef);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  public toggleMenu() {
    this.menuExpanded = !this.menuExpanded;
    if (this.isBrowser) {
      document.body.classList.toggle('admin-header-menu-open');
    }
  }

  /**
   * close menu if click outside
   */
  public closeMenuEventListener(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.menuExpanded = false;
      if (this.isBrowser) {
        document.body.classList.remove('admin-header-menu-open');
      }
    }
  }

  public get toggleId(): string {
    // Make value lowercase
    // Replace whitespaces with -
    // Append '-header-toggle' to the end of the string
    return this.menuName.trim().toLowerCase().replace(/\s+/g, '-') + '-header-toggle';
  }
}
